import { render, staticRenderFns } from "./EditAjustesDest.vue?vue&type=template&id=ed9e8472&scoped=true"
import script from "./EditAjustesDest.vue?vue&type=script&lang=js"
export * from "./EditAjustesDest.vue?vue&type=script&lang=js"
import style0 from "./EditAjustesDest.vue?vue&type=style&index=0&id=ed9e8472&prod&scoped=true&lang=css"
import style1 from "./EditAjustesDest.vue?vue&type=style&index=1&id=ed9e8472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9e8472",
  null
  
)

export default component.exports